<section class="cz-notification-dialog-component">
  <mat-dialog-title class="mat-dialog-title" *ngIf="!sendTemplate">
    <div class="row">
      <div class="col-xs-7">
          <h3 class="title">{{ notification?.title }}</h3>
      </div>
      <div class="col-xs-5 end-xs">
          <button mat-button mat-dialog-close class="mat-dialog-back-button">
              <mat-icon>close</mat-icon>
          </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-title class="mat-dialog-title" *ngIf="sendTemplate">
    <div class="row">
      <div class="col-xs-7">
          <!-- System users list bulk notification -->
          <h3 class="title" [innerHTML]="'$notification_new_notification_heading' | translate"></h3>
      </div>
      <div class="col-xs-5 end-xs">
          <button mat-button mat-dialog-close class="mat-dialog-back-button">
              <mat-icon>close</mat-icon>
          </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content *ngIf="!sendTemplate">
    <div class="row middle-xs">
      <div class="col-xs-8">
        <p class="font-size-large form-field"><span [innerHTML]="'$common_subject' | translate"></span>: <span>{{ notification?.title }}</span></p>
      </div>
      <div class="col-xs-4 end-xs">
        <p class="form-field">
          {{notification?.notificationDate | date:'MM-dd-yyyy'}}
        </p>
      </div>
    </div>
    <div class="row section">
      <div class="col-xs-12">
        <h4 class="font-size-large html-label"><span [innerHTML]="'$notification_message' | translate"></span>:</h4>
        <editor [apiKey]="tinyApiKey"
                [init]="descriptionDisplayConfig"
                [formControl]="descriptionControl"></editor>
        <!-- <p [innerHTML]="notification?.messageAsHtml" class="html-content font-size-large"></p> -->
      </div>
    </div>
  </mat-dialog-content>

  <form [formGroup]="notificationSendFormGroup" *ngIf="sendTemplate">
    <mat-dialog-content *ngIf="notificationTemplates && notificationTemplates.length > 0">
      <div class="row middle-xs">
        <div class="col-xs-8">
          <!-- System users list bulk notification -->
          <mat-form-field class="form-field form-field-full-width">
            <mat-label [innerHTML]="'$common_notification' | translate"></mat-label>
            <mat-select required [formControl]="notificationTemplateControl">
              <mat-option *ngFor="let notificationTemplate of notificationTemplates" [value]="notificationTemplate">{{ notificationTemplate.title }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xs-4 end-xs">
          <p class="form-field">
            {{ today | date:'MM-dd-yyyy'}}
          </p>
        </div>
      </div>
      <div class="row section">
        <div class="col-xs-12">
          <h4 class="font-size-large html-label"><span [innerHTML]="'$notification_message' | translate"></span>:</h4>
          <editor [apiKey]="tinyApiKey"
                  [init]="descriptionDisplayConfig"
                  [formControl]="descriptionControl"></editor>
          <!-- <p [innerHTML]="selectedTemplate?.textAsHtml" class="html-content font-size-large"></p> -->
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="!notificationTemplates || notificationTemplates.length < 1">
      <p>{{'$notifications_none_available' | translate}}</p>
    </mat-dialog-content>
  </form>
  <mat-actions  *ngIf="!sendTemplate || !notificationTemplates || notificationTemplates.length < 1">
    <div class="row">
      <div class="col-xs-6">
      </div>
      <div class="col-xs-6 end-xs">
        <p><button mat-flat-button class="link" color="primary" mat-dialog-close [innerHTML]="'$btn_close' | translate" ></button></p>
      </div>
    </div>
  </mat-actions>

  <mat-actions  *ngIf="sendTemplate && notificationTemplates && notificationTemplates.length > 0">
    <div class="row">
      <div class="col-xs-6">
        <!-- System users list bulk notification -->
        <p><button mat-button class="link" mat-dialog-close [innerHTML]="'$btn_cancel' | translate" ></button></p>
      </div>
      <div class="col-xs-6 end-xs">
        <!-- System users list bulk notification -->
        <p><button mat-flat-button class="link" color="accent" mat-dialog-close [innerHTML]="'$btn_send' | translate" (click)="sendNotification()"></button></p>
      </div>
    </div>
  </mat-actions>
</section>

